// src/components/Hero.jsx
import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { assets } from '../assets/assets.js';
import { NavLink } from 'react-router-dom';

const Hero = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
        color: 'white',
        textAlign: 'center',
        py: 8,
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${assets.hero01})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'brightness(0.6)',
          zIndex: -1,
        },
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h1"
          component="h1"
          sx={{ fontWeight: 'bold', mb: 2, textShadow: '2px 2px 8px rgba(0,0,0,0.6)' }}
        >
           Decorate Your Joy
        </Typography>
        <Typography
          variant="h5"
          component="p"
          sx={{ mb: 4, textShadow: '1px 1px 4px rgba(0,0,0,0.6)' }}
        >
          Discover fun and exciting party essentials, thoughtfully curated for your celebration
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          component={NavLink}
          to="/collection"
          sx={{ py: 1.5, px: 4 }}
        >
          Shop Now
        </Button>
      </Container>
    </Box>
  );
};

export default Hero;
